module.exports = __webpack_public_path__ + "img/male_4.ab207ff2.png";